module.exports = __webpack_public_path__ + "img/03-rocket-over-glow.325bd389.png";